const translations = {
  en: {
    // Nav
    "nav.home": "Home",
    "nav.shop": "Shop",
    "nav.wishlist": "Wishlist",
    "nav.cart": "Cart",
    "nav.admin": "Admin",
    "nav.search": "Search",
    // Hero
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "For Him. For Her.",
    "hero.subtitle": "Authenticated pre-owned luxury — handbags, crossbody, travel — for every wardrobe.",
    "hero.cta": "Explore Collection",
    // Home
    "home.featured": "Featured",
    "home.featured_subtitle": "Handpicked pieces from new arrivals",
    "home.brands": "Our Maisons",
    "home.brands_subtitle": "The world's most prestigious fashion houses",
    "home.view_all": "View All",
    "home.new_arrivals": "New Arrivals",
    // Shop
    "shop.title": "Collection",
    "shop.filters": "Filters",
    "shop.brand": "Brand",
    "shop.category": "Category",
    "shop.price": "Price Range",
    "shop.all": "All",
    "shop.clear": "Clear Filters",
    "shop.no_results": "No products found",
    "shop.results": "products",
    "shop.sort": "Sort",
    "shop.sort_popular": "Popular",
    "shop.sort_newest": "Newest",
    "shop.sort_price_asc": "Price: Low to High",
    "shop.sort_price_desc": "Price: High to Low",
    "shop.load_more": "Load More",
    "shop.loading": "Loading...",
    "search.placeholder": "Search bags, brands...",
    // Product
    "product.add_cart": "Add to Bag",
    "product.add_wishlist": "Add to Wishlist",
    "product.remove_wishlist": "Remove from Wishlist",
    "product.in_stock": "In Stock",
    "product.out_of_stock": "Out of Stock",
    "product.description": "Description",
    "product.details": "Details",
    "product.authenticity": "Authenticity Guarantee",
    "product.fast_delivery": "Fast Delivery",
    "product.max_stock": "Maximum available quantity reached",
    "product.further_info": "Further Information",
    "product.further_info_content": "All of our items come with an authenticity guarantee. To protect your investment, your product will arrive in a Mona Luxe dust bag and signature packaging.\n\nProducts sold by Mona Luxe are pre-owned unless stated otherwise. Our pieces have had a previous life and may tell their story through minor signs of wear. Major signs of wear will be noted in the item description.\n\nPlease note we are not affiliated with the brands that we sell.",
    "product.returns_shipping": "Returns and International Shipping",
    "product.returns_shipping_content": "INTERNATIONAL CLIENTS: Import duties and taxes are not included in your purchase price and will be billed separately by the courier. If you do not pay the import duties, your order will be returned to us. The tax will still be charged to our account, along with a return shipping fee and a €50 administration fee. These fees will be charged back to the client or deducted from store credit. Refunds will only be issued if the courier reimburses Mona Luxe for these costs, which is not guaranteed.\n\nRETURNS\n\nItems available on the Mona Luxe website are sold on a consignment basis. Mona Luxe does not accept returns for cash refunds on any purchased items. This policy is consistent with the consumer-to-consumer resale model used by other pre-loved platforms in the EU.\n\nGiven the pre-loved nature of our products, some items may show signs of wear. We strongly recommend that you carefully examine the descriptions and photographs before making a purchase. All items are sold as seen. We guarantee the authenticity of every item sold through Mona Luxe. If any item is found to be inauthentic, the buyer will receive a full refund.\n\nCustomers are responsible for the cost of return shipping. We can provide a shipping label for your convenience. If you opt to arrange your own shipping, you will bear the responsibility for tracking the shipment and for any loss or damage that may occur. International buyers must ensure that the customs declaration is accurately filled out for returns.\n\nReturning an order without the Mona Luxe dust bag will incur a €25 fee deducted from the store credit.\n\nNo returns are accepted on sale items. These items are considered final sale.\n\nFrom the date you receive your order, you have 2 days to contact our customer service team to initiate a return for an exchange or store credit. Once the return method is confirmed, the item must be returned within 5-7 days.\n\nORDER CANCELLATION\n\nIf you wish to cancel your order, please note that you will receive store credit instead of a cash refund.\n\nIN-STORE, SHOWROOM AND POP-UP PURCHASES\n\nReturns are not accepted for purchases made in-store or at pop-up events; all sales are final.",
    // Cart
    "cart.title": "Shopping Bag",
    "cart.empty": "Your bag is empty",
    "cart.empty_title": "Your Bag is Empty",
    "cart.empty_subtitle": "Browse our collection and find something you love",
    "cart.shop_now": "Shop Now",
    "cart.summary": "Order Summary",
    "cart.total": "Total",
    "cart.subtotal": "Subtotal",
    "cart.checkout": "Proceed to Checkout",
    "checkout.title": "Checkout",
    "checkout.proceed": "Continue to Checkout",
    "checkout.pay_now": "Pay Now",
    "checkout.back_to_cart": "Back to Cart",
    "checkout.first_name": "First Name",
    "checkout.last_name": "Last Name",
    "checkout.email": "Email",
    "checkout.phone": "Phone",
    "checkout.address": "Address",
    "checkout.city": "City",
    "checkout.postal_code": "Postal Code",
    "checkout.country": "Country",
    "checkout.discount_code": "Discount Code",
    "checkout.apply": "Apply",
    "checkout.discount": "Discount",
    "checkout.fill_required": "Please fill in required fields",
    "admin.create_code": "Create Code",
    "admin.type": "Type",
    "admin.percentage": "Percentage",
    "admin.fixed_amount": "Fixed Amount",
    "admin.value": "Value",
    "admin.usage_limit": "Usage Limit",
    "admin.min_order": "Min Order",
    "cart.remove": "Remove",
    "cart.quantity": "Qty",
    "cart.continue": "Continue Shopping",
    "cart.ship_to": "Ship to",
    "cart.select_country": "Select country",
    "cart.shipping": "Shipping",
    "cart.business_days": "business days",
    "cart.free": "Free",
    "cart.free_shipping": "Free shipping included",
    "cart.free_shipping_from": "Free shipping from",
    // Wishlist
    "wishlist.title": "Wishlist",
    "wishlist.empty": "Your wishlist is empty",
    "wishlist.move_to_cart": "Add to Bag",
    // Checkout
    "checkout.success": "Thank You for Your Purchase",
    "checkout.processing": "Processing your payment...",
    "checkout.failed": "Payment could not be processed",
    "checkout.continue": "Continue Shopping",
    "checkout.order_confirmed": "Your order has been confirmed",
    // Admin
    "admin.title": "Administration",
    "admin.login": "Login",
    "admin.password": "Password",
    "admin.products": "Products",
    "admin.orders": "Orders",
    "admin.add": "Add Product",
    "admin.edit": "Edit",
    "admin.delete": "Delete",
    "admin.upload_photo": "Upload Photo",
    "admin.stock_quantity": "Stock Quantity",
    "admin.discount": "Discount",
    "admin.save": "Save",
    "admin.cancel": "Cancel",
    "admin.name": "Name",
    "admin.brand": "Brand",
    "admin.category": "Category",
    "admin.price": "Price",
    "admin.description": "Description",
    "admin.images": "Image URLs (one per line)",
    "admin.featured": "Featured",
    "admin.in_stock": "In Stock",
    "admin.logout": "Logout",
    "admin.no_orders": "No orders yet",
    "admin.order_id": "Order ID",
    "admin.amount": "Amount",
    "admin.status": "Status",
    "admin.date": "Date",
    // Footer
    "footer.about": "About Mona Luxe",
    "footer.about_text": "A curated destination for the world's finest designer handbags. Each piece is authenticated and delivered with care.",
    "footer.customer_care": "Customer Care",
    "footer.shipping_info": "Shipping Information",
    "footer.returns_policy": "Returns & Exchanges",
    "footer.contact": "Contact Us",
    "footer.faq": "FAQ",
    "footer.authenticity": "Authenticity Guarantee",
    "footer.legal": "Legal",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",
    "footer.cookies": "Cookie Policy",
    "footer.follow": "Follow Us",
    "footer.newsletter": "Newsletter",
    "footer.newsletter_text": "Subscribe for exclusive access to new arrivals and private sales",
    "footer.subscribe": "Subscribe",
    "footer.email_placeholder": "Your email address",
    "footer.rights": "All rights reserved",
    // Common
    "common.loading": "Loading...",
    "common.error": "Something went wrong",
    "common.back": "Back",
    "common.close": "Close",
  },
  nl: {
    "nav.home": "Home",
    "nav.shop": "Winkel",
    "nav.wishlist": "Verlanglijst",
    "nav.cart": "Winkelwagen",
    "nav.admin": "Beheer",
    "nav.search": "Zoeken",
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "Voor Hem. Voor Haar.",
    "hero.subtitle": "Geauthentificeerde pre-owned luxe — handtassen, crossbody, reistassen — voor elke garderobe.",
    "hero.cta": "Ontdek Collectie",
    "home.featured": "Uitgelicht",
    "home.featured_subtitle": "Handgeselecteerde stukken uit nieuwe aankomsten",
    "home.brands": "Onze Modehuizen",
    "home.brands_subtitle": "De meest prestigieuze modehuizen ter wereld",
    "home.view_all": "Bekijk Alles",
    "home.new_arrivals": "Nieuw Binnen",
    "shop.title": "Collectie",
    "shop.filters": "Filters",
    "shop.brand": "Merk",
    "shop.category": "Categorie",
    "shop.price": "Prijsklasse",
    "shop.all": "Alle",
    "shop.clear": "Filters Wissen",
    "shop.no_results": "Geen producten gevonden",
    "shop.results": "producten",
    "shop.sort": "Sorteren",
    "shop.sort_popular": "Populair",
    "shop.sort_newest": "Nieuwste",
    "shop.sort_price_asc": "Prijs: Laag naar Hoog",
    "shop.sort_price_desc": "Prijs: Hoog naar Laag",
    "shop.load_more": "Meer Laden",
    "shop.loading": "Laden...",
    "search.placeholder": "Zoek tassen, merken...",
    "product.add_cart": "Toevoegen aan Tas",
    "product.add_wishlist": "Toevoegen aan Verlanglijst",
    "product.remove_wishlist": "Verwijderen van Verlanglijst",
    "product.in_stock": "Op Voorraad",
    "product.out_of_stock": "Niet Op Voorraad",
    "product.description": "Beschrijving",
    "product.details": "Details",
    "product.authenticity": "Authenticiteitgarantie",
    "product.fast_delivery": "Snelle Levering",
    "product.max_stock": "Maximaal beschikbaar aantal bereikt",
    "product.further_info": "Aanvullende Informatie",
    "product.further_info_content": "Al onze items worden geleverd met een echtheidsgarantie. Om uw investering te beschermen, wordt uw product geleverd in een Mona Luxe stoftas en kenmerkende verpakking.\n\nProducten van Mona Luxe zijn tweedehands tenzij anders vermeld. Onze stukken hebben een eerder leven gehad en kunnen hun verhaal vertellen door kleine gebruikssporen. Grotere gebruikssporen worden vermeld in de productomschrijving.\n\nLet op: wij zijn niet gelieerd aan de merken die wij verkopen.",
    "product.returns_shipping": "Retourneren en Internationale Verzending",
    "product.returns_shipping_content": "INTERNATIONALE KLANTEN: Invoerrechten en belastingen zijn niet inbegrepen in de aankoopprijs en worden apart in rekening gebracht door de koerier. Indien u de invoerrechten niet betaalt, wordt uw bestelling naar ons geretourneerd. De belasting wordt nog steeds in rekening gebracht op onze rekening, samen met retourverzendkosten en €50 administratiekosten. Deze kosten worden doorberekend aan de klant of in mindering gebracht op het winkeltegoed. Restituties worden alleen verleend als de koerier Mona Luxe deze kosten vergoedt, wat niet gegarandeerd is.\n\nRETOUREN\n\nItems op de Mona Luxe website worden aangeboden op consignatiebasis. Mona Luxe accepteert geen retouren voor cashrestituties op gekochte items. Dit beleid is in lijn met het consument-tot-consument verkoopmodel dat door andere pre-loved platformen in de EU wordt gehanteerd.\n\nGezien de pre-loved aard van onze producten kunnen sommige items gebruikssporen vertonen. Wij raden u sterk aan de beschrijvingen en foto's zorgvuldig te bekijken voordat u koopt. Alle items worden verkocht zoals afgebeeld. Wij garanderen de authenticiteit van elk via Mona Luxe verkocht item. Mocht een item niet authentiek blijken, dan ontvangt de koper een volledige terugbetaling.\n\nKlanten zijn verantwoordelijk voor de kosten van retourverzending. Wij kunnen voor uw gemak een verzendlabel verstrekken. Indien u zelf de verzending regelt, bent u verantwoordelijk voor het volgen van de zending en voor eventueel verlies of schade. Internationale kopers dienen ervoor te zorgen dat de douaneverklaring correct is ingevuld voor retouren.\n\nHet retourneren van een bestelling zonder de Mona Luxe stoftas brengt €25 aan kosten met zich mee, die in mindering worden gebracht op het winkeltegoed.\n\nSale-artikelen kunnen niet worden geretourneerd. Deze items worden beschouwd als final sale.\n\nVanaf de datum waarop u uw bestelling ontvangt, heeft u 2 dagen om contact op te nemen met onze klantenservice om een retour in te dienen voor ruil of winkeltegoed. Zodra de retourmethode is bevestigd, moet het artikel binnen 5-7 dagen worden geretourneerd.\n\nANNULERING VAN BESTELLING\n\nIndien u uw bestelling wilt annuleren, ontvangt u winkeltegoed in plaats van een contante restitutie.\n\nWINKEL, SHOWROOM EN POP-UP AANKOPEN\n\nRetouren worden niet geaccepteerd voor aankopen in de winkel of tijdens pop-up evenementen; alle verkopen zijn definitief.",
    "cart.title": "Winkeltas",
    "cart.empty": "Uw tas is leeg",
    "cart.empty_title": "Uw Tas is Leeg",
    "cart.empty_subtitle": "Bekijk onze collectie en vind iets dat u bevalt",
    "cart.shop_now": "Ga Winkelen",
    "cart.summary": "Overzicht",
    "cart.total": "Totaal",
    "cart.subtotal": "Subtotaal",
    "cart.checkout": "Afrekenen",
    "checkout.title": "Afrekenen",
    "checkout.proceed": "Doorgaan",
    "checkout.pay_now": "Nu Betalen",
    "checkout.back_to_cart": "Terug naar Winkelwagen",
    "checkout.first_name": "Voornaam",
    "checkout.last_name": "Achternaam",
    "checkout.email": "E-mail",
    "checkout.phone": "Telefoon",
    "checkout.address": "Adres",
    "checkout.city": "Stad",
    "checkout.postal_code": "Postcode",
    "checkout.country": "Land",
    "checkout.discount_code": "Kortingscode",
    "checkout.apply": "Toepassen",
    "checkout.discount": "Korting",
    "checkout.fill_required": "Vul verplichte velden in",
    "admin.create_code": "Code Aanmaken",
    "admin.type": "Type",
    "admin.percentage": "Percentage",
    "admin.fixed_amount": "Vast Bedrag",
    "admin.value": "Waarde",
    "admin.usage_limit": "Gebruikslimiet",
    "admin.min_order": "Min Bestelling",
    "cart.remove": "Verwijderen",
    "cart.quantity": "Aantal",
    "cart.continue": "Verder Winkelen",
    "cart.ship_to": "Verzenden naar",
    "cart.select_country": "Selecteer land",
    "cart.shipping": "Verzending",
    "cart.business_days": "werkdagen",
    "cart.free": "Gratis",
    "cart.free_shipping": "Gratis verzending inbegrepen",
    "cart.free_shipping_from": "Gratis verzending vanaf",
    "wishlist.title": "Verlanglijst",
    "wishlist.empty": "Uw verlanglijst is leeg",
    "wishlist.move_to_cart": "Toevoegen aan Tas",
    "checkout.success": "Bedankt voor Uw Aankoop",
    "checkout.processing": "Betaling wordt verwerkt...",
    "checkout.failed": "Betaling kon niet worden verwerkt",
    "checkout.continue": "Verder Winkelen",
    "checkout.order_confirmed": "Uw bestelling is bevestigd",
    "admin.title": "Beheer",
    "admin.login": "Inloggen",
    "admin.password": "Wachtwoord",
    "admin.products": "Producten",
    "admin.orders": "Bestellingen",
    "admin.add": "Product Toevoegen",
    "admin.edit": "Bewerken",
    "admin.delete": "Verwijderen",
    "admin.upload_photo": "Foto Uploaden",
    "admin.stock_quantity": "Voorraad",
    "admin.discount": "Korting",
    "admin.save": "Opslaan",
    "admin.cancel": "Annuleren",
    "admin.name": "Naam",
    "admin.brand": "Merk",
    "admin.category": "Categorie",
    "admin.price": "Prijs",
    "admin.description": "Beschrijving",
    "admin.images": "Afbeelding URLs (een per regel)",
    "admin.featured": "Uitgelicht",
    "admin.in_stock": "Op Voorraad",
    "admin.logout": "Uitloggen",
    "admin.no_orders": "Nog geen bestellingen",
    "admin.order_id": "Bestelling ID",
    "admin.amount": "Bedrag",
    "admin.status": "Status",
    "admin.date": "Datum",
    "footer.about": "Over Mona Luxe",
    "footer.about_text": "Een samengestelde bestemming voor 's werelds mooiste designertassen.",
    "footer.customer_care": "Klantenservice",
    "footer.shipping_info": "Verzendinformatie",
    "footer.returns_policy": "Retourneren & Omruilen",
    "footer.contact": "Contact",
    "footer.faq": "Veelgestelde Vragen",
    "footer.authenticity": "Authenticiteitgarantie",
    "footer.legal": "Juridisch",
    "footer.privacy": "Privacybeleid",
    "footer.terms": "Algemene Voorwaarden",
    "footer.cookies": "Cookiebeleid",
    "footer.follow": "Volg Ons",
    "footer.newsletter": "Nieuwsbrief",
    "footer.newsletter_text": "Abonneer voor exclusieve toegang tot nieuwe collecties",
    "footer.subscribe": "Abonneer",
    "footer.email_placeholder": "Uw e-mailadres",
    "footer.rights": "Alle rechten voorbehouden",
    "common.loading": "Laden...",
    "common.error": "Er ging iets mis",
    "common.back": "Terug",
    "common.close": "Sluiten",
  },
  de: {
    "nav.home": "Startseite",
    "nav.shop": "Shop",
    "nav.wishlist": "Wunschliste",
    "nav.cart": "Warenkorb",
    "nav.admin": "Verwaltung",
    "nav.search": "Suche",
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "Fuer Ihn. Fuer Sie.",
    "hero.subtitle": "Authentifizierter Pre-Owned-Luxus — Handtaschen, Crossbody, Reisetaschen — fuer jede Garderobe.",
    "hero.cta": "Kollektion Entdecken",
    "home.featured": "Empfohlen",
    "home.featured_subtitle": "Handverlesene Stucke aus neuen Eingaengen",
    "home.brands": "Unsere Haeuser",
    "home.brands_subtitle": "Die prestigetraechtigsten Modehaeuser der Welt",
    "home.view_all": "Alle Anzeigen",
    "home.new_arrivals": "Neuheiten",
    "shop.title": "Kollektion",
    "shop.filters": "Filter",
    "shop.brand": "Marke",
    "shop.category": "Kategorie",
    "shop.price": "Preisklasse",
    "shop.all": "Alle",
    "shop.clear": "Filter Loeschen",
    "shop.no_results": "Keine Produkte gefunden",
    "shop.results": "Produkte",
    "shop.sort": "Sortieren",
    "shop.sort_popular": "Beliebt",
    "shop.sort_newest": "Neueste",
    "shop.sort_price_asc": "Preis: Aufsteigend",
    "shop.sort_price_desc": "Preis: Absteigend",
    "shop.load_more": "Mehr Laden",
    "shop.loading": "Laden...",
    "search.placeholder": "Taschen, Marken suchen...",
    "product.add_cart": "In den Warenkorb",
    "product.add_wishlist": "Zur Wunschliste",
    "product.remove_wishlist": "Von Wunschliste entfernen",
    "product.in_stock": "Auf Lager",
    "product.out_of_stock": "Nicht Verfuegbar",
    "product.description": "Beschreibung",
    "product.details": "Details",
    "product.authenticity": "Echtheitsgarantie",
    "product.fast_delivery": "Schnelle Lieferung",
    "product.max_stock": "Maximale verfuegbare Menge erreicht",
    "product.further_info": "Weitere Informationen",
    "product.further_info_content": "Alle unsere Artikel werden mit einer Echtheitsgarantie geliefert. Zum Schutz Ihrer Investition wird Ihr Produkt in einem Mona Luxe Staubbeutel und in unserer charakteristischen Verpackung geliefert.\n\nProdukte von Mona Luxe sind, sofern nicht anders angegeben, gebraucht. Unsere Stuecke hatten ein frueheres Leben und koennen ihre Geschichte durch leichte Gebrauchsspuren erzaehlen. Groessere Gebrauchsspuren werden in der Produktbeschreibung erwaehnt.\n\nBitte beachten Sie, dass wir nicht mit den Marken affiliiert sind, die wir verkaufen.",
    "product.returns_shipping": "Ruecksendungen und Internationaler Versand",
    "product.returns_shipping_content": "INTERNATIONALE KUNDEN: Einfuhrzoelle und Steuern sind nicht im Kaufpreis enthalten und werden vom Kurier separat berechnet. Wenn Sie die Einfuhrzoelle nicht zahlen, wird Ihre Bestellung an uns zurueckgesendet. Die Steuer wird dennoch unserem Konto belastet, zusammen mit Ruecksendekosten und einer Verwaltungsgebuehr von 50 EUR. Diese Gebuehren werden dem Kunden in Rechnung gestellt oder von einem Guthaben abgezogen. Rueckerstattungen werden nur ausgezahlt, wenn der Kurier Mona Luxe diese Kosten erstattet, was nicht garantiert ist.\n\nRUECKSENDUNGEN\n\nDie auf der Mona Luxe Website angebotenen Artikel werden auf Kommissionsbasis verkauft. Mona Luxe akzeptiert keine Ruecksendungen mit Bargeld-Rueckerstattung. Diese Richtlinie entspricht dem Verbraucher-zu-Verbraucher-Verkaufsmodell, das von anderen Pre-loved-Plattformen in der EU verwendet wird.\n\nAngesichts des pre-loved Charakters unserer Produkte koennen einige Artikel Gebrauchsspuren aufweisen. Wir empfehlen dringend, die Beschreibungen und Fotos vor dem Kauf sorgfaeltig zu pruefen. Alle Artikel werden so verkauft, wie sie sind. Wir garantieren die Echtheit jedes ueber Mona Luxe verkauften Artikels. Sollte sich ein Artikel als nicht authentisch herausstellen, erhaelt der Kaeufer eine vollstaendige Rueckerstattung.\n\nKunden tragen die Kosten der Ruecksendung. Auf Wunsch koennen wir ein Versandetikett bereitstellen. Wenn Sie den Versand selbst organisieren, sind Sie fuer die Sendungsverfolgung sowie fuer eventuelle Verluste oder Schaeden verantwortlich. Internationale Kaeufer muessen sicherstellen, dass die Zollerklaerung fuer Ruecksendungen korrekt ausgefuellt ist.\n\nDie Rueckgabe einer Bestellung ohne den Mona Luxe Staubbeutel fuehrt zu einer Gebuehr von 25 EUR, die vom Guthaben abgezogen wird.\n\nReduzierte Artikel sind vom Umtausch ausgeschlossen. Diese Artikel gelten als Final Sale.\n\nAb dem Datum des Erhalts Ihrer Bestellung haben Sie 2 Tage Zeit, unseren Kundenservice zu kontaktieren, um eine Ruecksendung fuer einen Umtausch oder ein Guthaben einzuleiten. Nach Bestaetigung der Ruecksendemethode muss der Artikel innerhalb von 5-7 Tagen zurueckgesendet werden.\n\nBESTELLSTORNIERUNG\n\nWenn Sie Ihre Bestellung stornieren moechten, erhalten Sie ein Guthaben anstelle einer Bargeld-Rueckerstattung.\n\nLADEN-, SHOWROOM- UND POP-UP-KAEUFE\n\nRuecksendungen werden fuer Kaeufe in unserem Laden oder bei Pop-up-Events nicht akzeptiert; alle Verkaeufe sind endgueltig.",
    "cart.title": "Warenkorb",
    "cart.empty": "Ihr Warenkorb ist leer",
    "cart.empty_title": "Ihr Warenkorb ist Leer",
    "cart.empty_subtitle": "Entdecken Sie unsere Kollektion",
    "cart.shop_now": "Jetzt Einkaufen",
    "cart.summary": "Bestelluebersicht",
    "cart.total": "Gesamt",
    "cart.subtotal": "Zwischensumme",
    "cart.checkout": "Zur Kasse",
    "checkout.title": "Kasse",
    "checkout.proceed": "Weiter",
    "checkout.pay_now": "Jetzt Bezahlen",
    "checkout.back_to_cart": "Zurueck zum Warenkorb",
    "checkout.first_name": "Vorname",
    "checkout.last_name": "Nachname",
    "checkout.email": "E-Mail",
    "checkout.phone": "Telefon",
    "checkout.address": "Adresse",
    "checkout.city": "Stadt",
    "checkout.postal_code": "Postleitzahl",
    "checkout.country": "Land",
    "checkout.discount_code": "Rabattcode",
    "checkout.apply": "Anwenden",
    "checkout.discount": "Rabatt",
    "checkout.fill_required": "Bitte Pflichtfelder ausfuellen",
    "admin.create_code": "Code Erstellen",
    "admin.type": "Typ",
    "admin.percentage": "Prozent",
    "admin.fixed_amount": "Fester Betrag",
    "admin.value": "Wert",
    "admin.usage_limit": "Nutzungslimit",
    "admin.min_order": "Mindestbestellung",
    "cart.remove": "Entfernen",
    "cart.quantity": "Menge",
    "cart.continue": "Weiter Einkaufen",
    "cart.ship_to": "Versand nach",
    "cart.select_country": "Land auswaehlen",
    "cart.shipping": "Versand",
    "cart.business_days": "Werktage",
    "cart.free": "Gratis",
    "cart.free_shipping": "Versand inklusive",
    "cart.free_shipping_from": "Gratis Versand ab",
    "wishlist.title": "Wunschliste",
    "wishlist.empty": "Ihre Wunschliste ist leer",
    "wishlist.move_to_cart": "In den Warenkorb",
    "checkout.success": "Vielen Dank fuer Ihren Einkauf",
    "checkout.processing": "Zahlung wird verarbeitet...",
    "checkout.failed": "Zahlung konnte nicht verarbeitet werden",
    "checkout.continue": "Weiter Einkaufen",
    "checkout.order_confirmed": "Ihre Bestellung wurde bestaetigt",
    "admin.title": "Verwaltung",
    "admin.login": "Anmelden",
    "admin.password": "Passwort",
    "admin.products": "Produkte",
    "admin.orders": "Bestellungen",
    "admin.add": "Produkt Hinzufuegen",
    "admin.edit": "Bearbeiten",
    "admin.delete": "Loeschen",
    "admin.upload_photo": "Foto Hochladen",
    "admin.stock_quantity": "Lagerbestand",
    "admin.discount": "Rabatt",
    "admin.save": "Speichern",
    "admin.cancel": "Abbrechen",
    "admin.name": "Name",
    "admin.brand": "Marke",
    "admin.category": "Kategorie",
    "admin.price": "Preis",
    "admin.description": "Beschreibung",
    "admin.images": "Bild-URLs (eine pro Zeile)",
    "admin.featured": "Empfohlen",
    "admin.in_stock": "Auf Lager",
    "admin.logout": "Abmelden",
    "admin.no_orders": "Noch keine Bestellungen",
    "admin.order_id": "Bestellnummer",
    "admin.amount": "Betrag",
    "admin.status": "Status",
    "admin.date": "Datum",
    "footer.about": "Ueber Mona Luxe",
    "footer.about_text": "Ein kuratiertes Ziel fuer die feinsten Designerhandtaschen der Welt.",
    "footer.customer_care": "Kundenservice",
    "footer.shipping_info": "Versandinformationen",
    "footer.returns_policy": "Rueckgabe & Umtausch",
    "footer.contact": "Kontakt",
    "footer.faq": "Haeufig Gestellte Fragen",
    "footer.authenticity": "Echtheitsgarantie",
    "footer.legal": "Rechtliches",
    "footer.privacy": "Datenschutz",
    "footer.terms": "Allgemeine Geschaeftsbedingungen",
    "footer.cookies": "Cookie-Richtlinie",
    "footer.follow": "Folgen Sie Uns",
    "footer.newsletter": "Newsletter",
    "footer.newsletter_text": "Abonnieren Sie fuer exklusiven Zugang zu Neuheiten",
    "footer.subscribe": "Abonnieren",
    "footer.email_placeholder": "Ihre E-Mail-Adresse",
    "footer.rights": "Alle Rechte vorbehalten",
    "common.loading": "Laden...",
    "common.error": "Etwas ist schiefgelaufen",
    "common.back": "Zurueck",
    "common.close": "Schliessen",
  },
  fr: {
    "nav.home": "Accueil",
    "nav.shop": "Boutique",
    "nav.wishlist": "Favoris",
    "nav.cart": "Panier",
    "nav.admin": "Administration",
    "nav.search": "Rechercher",
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "Pour Lui. Pour Elle.",
    "hero.subtitle": "Luxe authentifie de seconde main — sacs a main, bandouliere, voyage — pour toutes les garde-robes.",
    "hero.cta": "Explorer la Collection",
    "home.featured": "Selection",
    "home.featured_subtitle": "Pieces selectionnees parmi les nouveautes",
    "home.brands": "Nos Maisons",
    "home.brands_subtitle": "Les maisons de mode les plus prestigieuses au monde",
    "home.view_all": "Voir Tout",
    "home.new_arrivals": "Nouveautes",
    "shop.title": "Collection",
    "shop.filters": "Filtres",
    "shop.brand": "Marque",
    "shop.category": "Categorie",
    "shop.price": "Gamme de Prix",
    "shop.all": "Tout",
    "shop.clear": "Effacer les Filtres",
    "shop.no_results": "Aucun produit trouve",
    "shop.results": "produits",
    "shop.sort": "Trier",
    "shop.sort_popular": "Populaires",
    "shop.sort_newest": "Nouveautes",
    "shop.sort_price_asc": "Prix: Croissant",
    "shop.sort_price_desc": "Prix: Decroissant",
    "shop.load_more": "Charger Plus",
    "shop.loading": "Chargement...",
    "search.placeholder": "Rechercher sacs, marques...",
    "product.add_cart": "Ajouter au Panier",
    "product.add_wishlist": "Ajouter aux Favoris",
    "product.remove_wishlist": "Retirer des Favoris",
    "product.in_stock": "En Stock",
    "product.out_of_stock": "Rupture de Stock",
    "product.description": "Description",
    "product.details": "Details",
    "product.authenticity": "Garantie d'Authenticite",
    "product.fast_delivery": "Livraison Rapide",
    "product.max_stock": "Quantite maximale disponible atteinte",
    "product.further_info": "Informations Complementaires",
    "product.further_info_content": "Tous nos articles sont accompagnes d'une garantie d'authenticite. Pour proteger votre investissement, votre produit sera livre dans une pochette Mona Luxe et son emballage signature.\n\nLes produits vendus par Mona Luxe sont d'occasion sauf indication contraire. Nos pieces ont eu une vie anterieure et peuvent raconter leur histoire a travers de legers signes d'usure. Des signes d'usure plus marques seront indiques dans la description du produit.\n\nVeuillez noter que nous ne sommes pas affilies aux marques que nous vendons.",
    "product.returns_shipping": "Retours et Livraison Internationale",
    "product.returns_shipping_content": "CLIENTS INTERNATIONAUX: Les droits de douane et taxes ne sont pas inclus dans le prix d'achat et seront factures separement par le transporteur. Si vous ne payez pas les droits de douane, votre commande nous sera retournee. La taxe restera a notre charge, avec des frais de retour et 50 EUR de frais administratifs. Ces frais seront factures au client ou deduits du credit en magasin. Les remboursements ne seront effectues que si le transporteur rembourse Mona Luxe pour ces frais, ce qui n'est pas garanti.\n\nRETOURS\n\nLes articles disponibles sur le site Mona Luxe sont vendus en consignation. Mona Luxe n'accepte pas les retours pour un remboursement en especes sur les articles achetes. Cette politique est conforme au modele de vente consommateur-a-consommateur utilise par d'autres plateformes pre-loved en UE.\n\nEtant donne la nature pre-loved de nos produits, certains articles peuvent presenter des signes d'usure. Nous vous recommandons fortement d'examiner attentivement les descriptions et les photographies avant l'achat. Tous les articles sont vendus tels quels. Nous garantissons l'authenticite de chaque article vendu via Mona Luxe. Si un article s'avere non authentique, l'acheteur recevra un remboursement integral.\n\nLes clients sont responsables des frais de retour. Nous pouvons fournir une etiquette d'expedition pour votre confort. Si vous choisissez d'organiser votre propre expedition, vous serez responsable du suivi du colis et des pertes ou dommages eventuels. Les acheteurs internationaux doivent s'assurer que la declaration en douane est correctement remplie pour les retours.\n\nLe retour d'une commande sans la pochette Mona Luxe entrainera des frais de 25 EUR deduits du credit en magasin.\n\nLes articles soldes ne sont pas retournables. Ces articles sont consideres comme des ventes finales.\n\nA compter de la date de reception de votre commande, vous disposez de 2 jours pour contacter notre service client afin d'initier un retour pour un echange ou un credit en magasin. Une fois la methode de retour confirmee, l'article doit etre retourne dans les 5-7 jours.\n\nANNULATION DE COMMANDE\n\nSi vous souhaitez annuler votre commande, vous recevrez un credit en magasin au lieu d'un remboursement en especes.\n\nACHATS EN BOUTIQUE, SHOWROOM ET POP-UP\n\nLes retours ne sont pas acceptes pour les achats effectues en boutique ou lors d'evenements pop-up; toutes les ventes sont definitives.",
    "cart.title": "Panier",
    "cart.empty": "Votre panier est vide",
    "cart.empty_title": "Votre Panier est Vide",
    "cart.empty_subtitle": "Parcourez notre collection",
    "cart.shop_now": "Acheter Maintenant",
    "cart.summary": "Resume de la Commande",
    "cart.total": "Total",
    "cart.subtotal": "Sous-total",
    "cart.checkout": "Passer a la Caisse",
    "checkout.title": "Paiement",
    "checkout.proceed": "Continuer",
    "checkout.pay_now": "Payer Maintenant",
    "checkout.back_to_cart": "Retour au Panier",
    "checkout.first_name": "Prenom",
    "checkout.last_name": "Nom",
    "checkout.email": "E-mail",
    "checkout.phone": "Telephone",
    "checkout.address": "Adresse",
    "checkout.city": "Ville",
    "checkout.postal_code": "Code Postal",
    "checkout.country": "Pays",
    "checkout.discount_code": "Code Promo",
    "checkout.apply": "Appliquer",
    "checkout.discount": "Remise",
    "checkout.fill_required": "Veuillez remplir les champs obligatoires",
    "admin.create_code": "Creer Code",
    "admin.type": "Type",
    "admin.percentage": "Pourcentage",
    "admin.fixed_amount": "Montant Fixe",
    "admin.value": "Valeur",
    "admin.usage_limit": "Limite",
    "admin.min_order": "Commande Min",
    "cart.remove": "Supprimer",
    "cart.quantity": "Qte",
    "cart.continue": "Continuer les Achats",
    "cart.ship_to": "Livraison a",
    "cart.select_country": "Choisir un pays",
    "cart.shipping": "Livraison",
    "cart.business_days": "jours ouvres",
    "cart.free": "Offerte",
    "cart.free_shipping": "Livraison offerte incluse",
    "cart.free_shipping_from": "Livraison offerte des",
    "wishlist.title": "Favoris",
    "wishlist.empty": "Votre liste de favoris est vide",
    "wishlist.move_to_cart": "Ajouter au Panier",
    "checkout.success": "Merci pour Votre Achat",
    "checkout.processing": "Traitement du paiement...",
    "checkout.failed": "Le paiement n'a pas pu etre traite",
    "checkout.continue": "Continuer les Achats",
    "checkout.order_confirmed": "Votre commande est confirmee",
    "admin.title": "Administration",
    "admin.login": "Connexion",
    "admin.password": "Mot de passe",
    "admin.products": "Produits",
    "admin.orders": "Commandes",
    "admin.add": "Ajouter un Produit",
    "admin.edit": "Modifier",
    "admin.delete": "Supprimer",
    "admin.upload_photo": "Telecharger Photo",
    "admin.stock_quantity": "Quantite en Stock",
    "admin.discount": "Remise",
    "admin.save": "Enregistrer",
    "admin.cancel": "Annuler",
    "admin.name": "Nom",
    "admin.brand": "Marque",
    "admin.category": "Categorie",
    "admin.price": "Prix",
    "admin.description": "Description",
    "admin.images": "URLs d'images (une par ligne)",
    "admin.featured": "En Vedette",
    "admin.in_stock": "En Stock",
    "admin.logout": "Deconnexion",
    "admin.no_orders": "Pas encore de commandes",
    "admin.order_id": "N de commande",
    "admin.amount": "Montant",
    "admin.status": "Statut",
    "admin.date": "Date",
    "footer.about": "A Propos de Mona Luxe",
    "footer.about_text": "Une destination selectionnee pour les plus beaux sacs de createurs.",
    "footer.customer_care": "Service Client",
    "footer.shipping_info": "Informations de Livraison",
    "footer.returns_policy": "Retours & Echanges",
    "footer.contact": "Nous Contacter",
    "footer.faq": "FAQ",
    "footer.authenticity": "Authenticity Guarantee",
    "footer.legal": "Mentions Legales",
    "footer.privacy": "Politique de Confidentialite",
    "footer.terms": "Conditions Generales",
    "footer.cookies": "Politique de Cookies",
    "footer.follow": "Suivez-Nous",
    "footer.newsletter": "Newsletter",
    "footer.newsletter_text": "Abonnez-vous pour un acces exclusif aux nouveautes",
    "footer.subscribe": "S'abonner",
    "footer.email_placeholder": "Votre adresse email",
    "footer.rights": "Tous droits reserves",
    "common.loading": "Chargement...",
    "common.error": "Quelque chose s'est mal passe",
    "common.back": "Retour",
    "common.close": "Fermer",
  },
  es: {
    "nav.home": "Inicio",
    "nav.shop": "Tienda",
    "nav.wishlist": "Favoritos",
    "nav.cart": "Carrito",
    "nav.admin": "Administracion",
    "nav.search": "Buscar",
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "Para El. Para Ella.",
    "hero.subtitle": "Lujo autenticado de segunda mano — bolsos, bandolera, viaje — para cada guardarropa.",
    "hero.cta": "Explorar Coleccion",
    "home.featured": "Destacados",
    "home.featured_subtitle": "Piezas seleccionadas de las nuevas llegadas",
    "home.brands": "Nuestras Casas",
    "home.brands_subtitle": "Las casas de moda mas prestigiosas del mundo",
    "home.view_all": "Ver Todo",
    "home.new_arrivals": "Novedades",
    "shop.title": "Coleccion",
    "shop.filters": "Filtros",
    "shop.brand": "Marca",
    "shop.category": "Categoria",
    "shop.price": "Rango de Precio",
    "shop.all": "Todo",
    "shop.clear": "Limpiar Filtros",
    "shop.no_results": "No se encontraron productos",
    "shop.results": "productos",
    "shop.sort": "Ordenar",
    "shop.sort_popular": "Populares",
    "shop.sort_newest": "Mas Recientes",
    "shop.sort_price_asc": "Precio: Menor a Mayor",
    "shop.sort_price_desc": "Precio: Mayor a Menor",
    "shop.load_more": "Cargar Mas",
    "shop.loading": "Cargando...",
    "search.placeholder": "Buscar bolsos, marcas...",
    "product.add_cart": "Agregar al Carrito",
    "product.add_wishlist": "Agregar a Favoritos",
    "product.remove_wishlist": "Quitar de Favoritos",
    "product.in_stock": "En Stock",
    "product.out_of_stock": "Agotado",
    "product.description": "Descripcion",
    "product.details": "Detalles",
    "product.authenticity": "Garantia de Autenticidad",
    "product.fast_delivery": "Entrega Rapida",
    "product.max_stock": "Cantidad maxima disponible alcanzada",
    "product.further_info": "Informacion Adicional",
    "product.further_info_content": "Todos nuestros articulos vienen con una garantia de autenticidad. Para proteger su inversion, su producto llegara en una bolsa de polvo Mona Luxe y embalaje distintivo.\n\nLos productos vendidos por Mona Luxe son de segunda mano salvo indicacion contraria. Nuestras piezas han tenido una vida previa y pueden mostrar pequenos signos de uso. Los signos de uso mas marcados se indicaran en la descripcion del producto.\n\nTenga en cuenta que no estamos afiliados a las marcas que vendemos.",
    "product.returns_shipping": "Devoluciones y Envio Internacional",
    "product.returns_shipping_content": "CLIENTES INTERNACIONALES: Los aranceles e impuestos de importacion no estan incluidos en el precio de compra y seran facturados por separado por el transportista. Si no paga los aranceles de importacion, su pedido nos sera devuelto. El impuesto seguira siendo cargado a nuestra cuenta, junto con un cargo de envio de devolucion y una tarifa administrativa de 50 EUR. Estos cargos seran facturados al cliente o deducidos del credito de tienda. Los reembolsos solo se emitiran si el transportista reembolsa a Mona Luxe estos costos, lo cual no esta garantizado.\n\nDEVOLUCIONES\n\nLos articulos disponibles en el sitio web de Mona Luxe se venden en consignacion. Mona Luxe no acepta devoluciones con reembolso en efectivo. Esta politica es coherente con el modelo de venta consumidor-a-consumidor utilizado por otras plataformas pre-loved en la UE.\n\nDada la naturaleza pre-loved de nuestros productos, algunos articulos pueden presentar signos de uso. Le recomendamos encarecidamente examinar cuidadosamente las descripciones y fotografias antes de comprar. Todos los articulos se venden tal cual. Garantizamos la autenticidad de cada articulo vendido a traves de Mona Luxe. Si un articulo resulta no autentico, el comprador recibira un reembolso completo.\n\nLos clientes son responsables del costo de envio de devolucion. Podemos proporcionar una etiqueta de envio para su comodidad. Si decide organizar su propio envio, sera responsable del seguimiento del paquete y de cualquier perdida o dano. Los compradores internacionales deben asegurarse de que la declaracion aduanera este correctamente completada para las devoluciones.\n\nDevolver un pedido sin la bolsa de polvo Mona Luxe incurrira en un cargo de 25 EUR deducido del credito de tienda.\n\nLos articulos en oferta no son retornables. Estos articulos se consideran venta final.\n\nDesde la fecha en que recibe su pedido, tiene 2 dias para contactar a nuestro servicio al cliente para iniciar una devolucion por cambio o credito de tienda. Una vez confirmado el metodo de devolucion, el articulo debe ser devuelto dentro de 5-7 dias.\n\nCANCELACION DE PEDIDO\n\nSi desea cancelar su pedido, recibira credito de tienda en lugar de un reembolso en efectivo.\n\nCOMPRAS EN TIENDA, SHOWROOM Y POP-UP\n\nNo se aceptan devoluciones para compras realizadas en tienda o en eventos pop-up; todas las ventas son finales.",
    "cart.title": "Carrito de Compras",
    "cart.empty": "Tu carrito esta vacio",
    "cart.empty_title": "Tu Carrito esta Vacio",
    "cart.empty_subtitle": "Explora nuestra coleccion",
    "cart.shop_now": "Comprar Ahora",
    "cart.summary": "Resumen del Pedido",
    "cart.total": "Total",
    "cart.subtotal": "Subtotal",
    "cart.checkout": "Proceder al Pago",
    "checkout.title": "Pago",
    "checkout.proceed": "Continuar",
    "checkout.pay_now": "Pagar Ahora",
    "checkout.back_to_cart": "Volver al Carrito",
    "checkout.first_name": "Nombre",
    "checkout.last_name": "Apellido",
    "checkout.email": "Correo",
    "checkout.phone": "Telefono",
    "checkout.address": "Direccion",
    "checkout.city": "Ciudad",
    "checkout.postal_code": "Codigo Postal",
    "checkout.country": "Pais",
    "checkout.discount_code": "Codigo de Descuento",
    "checkout.apply": "Aplicar",
    "checkout.discount": "Descuento",
    "checkout.fill_required": "Rellene los campos obligatorios",
    "admin.create_code": "Crear Codigo",
    "admin.type": "Tipo",
    "admin.percentage": "Porcentaje",
    "admin.fixed_amount": "Monto Fijo",
    "admin.value": "Valor",
    "admin.usage_limit": "Limite de Uso",
    "admin.min_order": "Pedido Min",
    "cart.remove": "Eliminar",
    "cart.quantity": "Cant.",
    "cart.continue": "Seguir Comprando",
    "cart.ship_to": "Enviar a",
    "cart.select_country": "Selecciona pais",
    "cart.shipping": "Envio",
    "cart.business_days": "dias habiles",
    "cart.free": "Gratis",
    "cart.free_shipping": "Envio gratis incluido",
    "cart.free_shipping_from": "Envio gratis desde",
    "wishlist.title": "Favoritos",
    "wishlist.empty": "Tu lista de favoritos esta vacia",
    "wishlist.move_to_cart": "Agregar al Carrito",
    "checkout.success": "Gracias por Tu Compra",
    "checkout.processing": "Procesando tu pago...",
    "checkout.failed": "El pago no pudo ser procesado",
    "checkout.continue": "Seguir Comprando",
    "checkout.order_confirmed": "Tu pedido ha sido confirmado",
    "admin.title": "Administracion",
    "admin.login": "Iniciar Sesion",
    "admin.password": "Contrasena",
    "admin.products": "Productos",
    "admin.orders": "Pedidos",
    "admin.add": "Agregar Producto",
    "admin.edit": "Editar",
    "admin.delete": "Eliminar",
    "admin.upload_photo": "Subir Foto",
    "admin.stock_quantity": "Cantidad en Stock",
    "admin.discount": "Descuento",
    "admin.save": "Guardar",
    "admin.cancel": "Cancelar",
    "admin.name": "Nombre",
    "admin.brand": "Marca",
    "admin.category": "Categoria",
    "admin.price": "Precio",
    "admin.description": "Descripcion",
    "admin.images": "URLs de imagenes (una por linea)",
    "admin.featured": "Destacado",
    "admin.in_stock": "En Stock",
    "admin.logout": "Cerrar Sesion",
    "admin.no_orders": "Aun no hay pedidos",
    "admin.order_id": "ID de Pedido",
    "admin.amount": "Monto",
    "admin.status": "Estado",
    "admin.date": "Fecha",
    "footer.about": "Sobre Mona Luxe",
    "footer.about_text": "Un destino selecto para los mejores bolsos de disenador.",
    "footer.customer_care": "Atencion al Cliente",
    "footer.shipping_info": "Informacion de Envio",
    "footer.returns_policy": "Devoluciones y Cambios",
    "footer.contact": "Contacto",
    "footer.faq": "Preguntas Frecuentes",
    "footer.authenticity": "Garantia de Autenticidad",
    "footer.legal": "Legal",
    "footer.privacy": "Politica de Privacidad",
    "footer.terms": "Terminos de Servicio",
    "footer.cookies": "Politica de Cookies",
    "footer.follow": "Siguenos",
    "footer.newsletter": "Boletin",
    "footer.newsletter_text": "Suscribete para acceso exclusivo a novedades",
    "footer.subscribe": "Suscribirse",
    "footer.email_placeholder": "Tu correo electronico",
    "footer.rights": "Todos los derechos reservados",
    "common.loading": "Cargando...",
    "common.error": "Algo salio mal",
    "common.back": "Volver",
    "common.close": "Cerrar",
  },
  it: {
    "nav.home": "Home",
    "nav.shop": "Negozio",
    "nav.wishlist": "Preferiti",
    "nav.cart": "Carrello",
    "nav.admin": "Amministrazione",
    "nav.search": "Cerca",
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "Per Lui. Per Lei.",
    "hero.subtitle": "Lusso pre-owned autenticato — borse, tracolla, viaggio — per ogni guardaroba.",
    "hero.cta": "Esplora la Collezione",
    "home.featured": "In Evidenza",
    "home.featured_subtitle": "Pezzi selezionati dai nuovi arrivi",
    "home.brands": "Le Nostre Maison",
    "home.brands_subtitle": "Le maison di moda piu prestigiose al mondo",
    "home.view_all": "Vedi Tutto",
    "home.new_arrivals": "Novita",
    "shop.title": "Collezione",
    "shop.filters": "Filtri",
    "shop.brand": "Marca",
    "shop.category": "Categoria",
    "shop.price": "Fascia di Prezzo",
    "shop.all": "Tutti",
    "shop.clear": "Cancella Filtri",
    "shop.no_results": "Nessun prodotto trovato",
    "shop.results": "prodotti",
    "shop.sort": "Ordina",
    "shop.sort_popular": "Popolari",
    "shop.sort_newest": "Piu Recenti",
    "shop.sort_price_asc": "Prezzo: Crescente",
    "shop.sort_price_desc": "Prezzo: Decrescente",
    "shop.load_more": "Carica Altro",
    "shop.loading": "Caricamento...",
    "search.placeholder": "Cerca borse, marche...",
    "product.add_cart": "Aggiungi al Carrello",
    "product.add_wishlist": "Aggiungi ai Preferiti",
    "product.remove_wishlist": "Rimuovi dai Preferiti",
    "product.in_stock": "Disponibile",
    "product.out_of_stock": "Non Disponibile",
    "product.description": "Descrizione",
    "product.details": "Dettagli",
    "product.authenticity": "Garanzia di Autenticita",
    "product.fast_delivery": "Consegna Rapida",
    "product.max_stock": "Quantita massima disponibile raggiunta",
    "product.further_info": "Informazioni Aggiuntive",
    "product.further_info_content": "Tutti i nostri articoli sono accompagnati da una garanzia di autenticita. Per proteggere il suo investimento, il prodotto verra consegnato in una custodia antipolvere Mona Luxe e nel nostro imballaggio caratteristico.\n\nI prodotti venduti da Mona Luxe sono di seconda mano salvo diversa indicazione. I nostri pezzi hanno avuto una vita precedente e possono mostrare lievi segni di usura. Eventuali segni di usura piu marcati saranno indicati nella descrizione del prodotto.\n\nLa preghiamo di notare che non siamo affiliati ai marchi che vendiamo.",
    "product.returns_shipping": "Resi e Spedizione Internazionale",
    "product.returns_shipping_content": "CLIENTI INTERNAZIONALI: I dazi doganali e le tasse di importazione non sono inclusi nel prezzo di acquisto e verranno fatturati separatamente dal corriere. Se non paga i dazi doganali, il suo ordine ci verra restituito. L'imposta verra comunque addebitata sul nostro conto, insieme alle spese di spedizione di reso e una commissione amministrativa di 50 EUR. Queste spese verranno addebitate al cliente o detratte dal credito negozio. I rimborsi verranno emessi solo se il corriere rimborsera Mona Luxe per questi costi, il che non e garantito.\n\nRESI\n\nGli articoli disponibili sul sito Mona Luxe sono venduti in conto vendita. Mona Luxe non accetta resi per rimborsi in contanti sugli articoli acquistati. Questa politica e coerente con il modello di vendita da consumatore a consumatore utilizzato da altre piattaforme pre-loved nell'UE.\n\nData la natura pre-loved dei nostri prodotti, alcuni articoli possono mostrare segni di usura. Si raccomanda vivamente di esaminare attentamente le descrizioni e le fotografie prima dell'acquisto. Tutti gli articoli sono venduti cosi come sono. Garantiamo l'autenticita di ogni articolo venduto tramite Mona Luxe. Se un articolo dovesse risultare non autentico, l'acquirente ricevera un rimborso completo.\n\nI clienti sono responsabili del costo di spedizione del reso. Possiamo fornire un'etichetta di spedizione per la sua comodita. Se sceglie di organizzare la spedizione, sara responsabile del monitoraggio della spedizione e di eventuali perdite o danni. Gli acquirenti internazionali devono assicurarsi che la dichiarazione doganale sia compilata correttamente per i resi.\n\nLa restituzione di un ordine senza la custodia antipolvere Mona Luxe comportera una commissione di 25 EUR detratta dal credito negozio.\n\nGli articoli in saldo non sono restituibili. Questi articoli sono considerati vendita finale.\n\nDalla data di ricezione dell'ordine, ha 2 giorni per contattare il nostro servizio clienti per avviare un reso per cambio o credito negozio. Una volta confermato il metodo di reso, l'articolo deve essere restituito entro 5-7 giorni.\n\nANNULLAMENTO DELL'ORDINE\n\nSe desidera annullare il suo ordine, ricevera credito negozio invece di un rimborso in contanti.\n\nACQUISTI IN NEGOZIO, SHOWROOM E POP-UP\n\nI resi non sono accettati per acquisti effettuati in negozio o durante eventi pop-up; tutte le vendite sono definitive.",
    "cart.title": "Carrello",
    "cart.empty": "Il tuo carrello e vuoto",
    "cart.empty_title": "Il Tuo Carrello e Vuoto",
    "cart.empty_subtitle": "Scopri la nostra collezione",
    "cart.shop_now": "Acquista Ora",
    "cart.summary": "Riepilogo Ordine",
    "cart.total": "Totale",
    "cart.subtotal": "Subtotale",
    "cart.checkout": "Procedi al Pagamento",
    "checkout.title": "Pagamento",
    "checkout.proceed": "Continua",
    "checkout.pay_now": "Paga Ora",
    "checkout.back_to_cart": "Torna al Carrello",
    "checkout.first_name": "Nome",
    "checkout.last_name": "Cognome",
    "checkout.email": "E-mail",
    "checkout.phone": "Telefono",
    "checkout.address": "Indirizzo",
    "checkout.city": "Citta",
    "checkout.postal_code": "CAP",
    "checkout.country": "Paese",
    "checkout.discount_code": "Codice Sconto",
    "checkout.apply": "Applica",
    "checkout.discount": "Sconto",
    "checkout.fill_required": "Compilare i campi obbligatori",
    "admin.create_code": "Crea Codice",
    "admin.type": "Tipo",
    "admin.percentage": "Percentuale",
    "admin.fixed_amount": "Importo Fisso",
    "admin.value": "Valore",
    "admin.usage_limit": "Limite Utilizzo",
    "admin.min_order": "Ordine Min",
    "cart.remove": "Rimuovi",
    "cart.quantity": "Qta",
    "cart.continue": "Continua lo Shopping",
    "cart.ship_to": "Spedizione a",
    "cart.select_country": "Seleziona paese",
    "cart.shipping": "Spedizione",
    "cart.business_days": "giorni lavorativi",
    "cart.free": "Gratis",
    "cart.free_shipping": "Spedizione gratuita inclusa",
    "cart.free_shipping_from": "Spedizione gratuita da €1.000",
    "wishlist.title": "Preferiti",
    "wishlist.empty": "La tua lista preferiti e vuota",
    "wishlist.move_to_cart": "Aggiungi al Carrello",
    "checkout.success": "Grazie per il Tuo Acquisto",
    "checkout.processing": "Elaborazione del pagamento...",
    "checkout.failed": "Il pagamento non e stato elaborato",
    "checkout.continue": "Continua lo Shopping",
    "checkout.order_confirmed": "Il tuo ordine e stato confermato",
    "admin.title": "Amministrazione",
    "admin.login": "Accedi",
    "admin.password": "Password",
    "admin.products": "Prodotti",
    "admin.orders": "Ordini",
    "admin.add": "Aggiungi Prodotto",
    "admin.edit": "Modifica",
    "admin.delete": "Elimina",
    "admin.upload_photo": "Carica Foto",
    "admin.stock_quantity": "Quantita in Magazzino",
    "admin.discount": "Sconto",
    "admin.save": "Salva",
    "admin.cancel": "Annulla",
    "admin.name": "Nome",
    "admin.brand": "Marca",
    "admin.category": "Categoria",
    "admin.price": "Prezzo",
    "admin.description": "Descrizione",
    "admin.images": "URL immagini (uno per riga)",
    "admin.featured": "In Evidenza",
    "admin.in_stock": "Disponibile",
    "admin.logout": "Esci",
    "admin.no_orders": "Nessun ordine ancora",
    "admin.order_id": "ID Ordine",
    "admin.amount": "Importo",
    "admin.status": "Stato",
    "admin.date": "Data",
    "footer.about": "Chi Siamo - Mona Luxe",
    "footer.about_text": "Una destinazione curata per le piu raffinate borse di design.",
    "footer.customer_care": "Assistenza Clienti",
    "footer.shipping_info": "Informazioni sulla Spedizione",
    "footer.returns_policy": "Resi e Cambi",
    "footer.contact": "Contattaci",
    "footer.faq": "Domande Frequenti",
    "footer.authenticity": "Garanzia di Autenticita",
    "footer.legal": "Note Legali",
    "footer.privacy": "Politica sulla Privacy",
    "footer.terms": "Termini di Servizio",
    "footer.cookies": "Politica sui Cookie",
    "footer.follow": "Seguici",
    "footer.newsletter": "Newsletter",
    "footer.newsletter_text": "Iscriviti per accesso esclusivo alle novita",
    "footer.subscribe": "Iscriviti",
    "footer.email_placeholder": "Il tuo indirizzo email",
    "footer.rights": "Tutti i diritti riservati",
    "common.loading": "Caricamento...",
    "common.error": "Qualcosa e andato storto",
    "common.back": "Indietro",
    "common.close": "Chiudi",
  },
  pl: {
    "nav.home": "Strona Glowna",
    "nav.shop": "Sklep",
    "nav.wishlist": "Lista Zyczen",
    "nav.cart": "Koszyk",
    "nav.admin": "Administracja",
    "nav.search": "Szukaj",
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "Dla Niego. Dla Niej.",
    "hero.subtitle": "Uwierzytelniony luksus z drugiej reki — torebki, crossbody, podrozne — do kazdej garderoby.",
    "hero.cta": "Odkryj Kolekcje",
    "hero.cta": "Odkryj Kolekcje",
    "home.featured": "Wyroznienie",
    "home.featured_subtitle": "Recznie wybrane modele z nowych dostaw",
    "home.brands": "Nasze Domy Mody",
    "home.brands_subtitle": "Najprestizowsze domy mody na swiecie",
    "home.view_all": "Zobacz Wszystko",
    "home.new_arrivals": "Nowosci",
    "shop.title": "Kolekcja",
    "shop.filters": "Filtry",
    "shop.brand": "Marka",
    "shop.category": "Kategoria",
    "shop.price": "Przedzial Cenowy",
    "shop.all": "Wszystko",
    "shop.clear": "Wyczysc Filtry",
    "shop.no_results": "Nie znaleziono produktow",
    "shop.results": "produktow",
    "shop.sort": "Sortuj",
    "shop.sort_popular": "Popularne",
    "shop.sort_newest": "Najnowsze",
    "shop.sort_price_asc": "Cena: Rosnaco",
    "shop.sort_price_desc": "Cena: Malejaco",
    "shop.load_more": "Zaladuj Wiecej",
    "shop.loading": "Ladowanie...",
    "search.placeholder": "Szukaj torebek, marek...",
    "product.add_cart": "Dodaj do Koszyka",
    "product.add_wishlist": "Dodaj do Listy Zyczen",
    "product.remove_wishlist": "Usun z Listy Zyczen",
    "product.in_stock": "Dostepny",
    "product.out_of_stock": "Niedostepny",
    "product.description": "Opis",
    "product.details": "Szczegoly",
    "product.authenticity": "Gwarancja Autentycznosci",
    "product.fast_delivery": "Szybka Dostawa",
    "product.max_stock": "Osiagnieto maksymalna dostepna ilosc",
    "product.further_info": "Dodatkowe Informacje",
    "product.further_info_content": "Wszystkie nasze przedmioty objete sa gwarancja autentycznosci. Aby chronic Twoja inwestycje, produkt zostanie dostarczony w worku przeciwkurzowym Mona Luxe i charakterystycznym opakowaniu.\n\nProdukty sprzedawane przez Mona Luxe sa uzywane, chyba ze zaznaczono inaczej. Nasze egzemplarze mialy poprzednie zycie i moga opowiadac swoja historie poprzez drobne slady uzytkowania. Wieksze slady uzytkowania beda wymienione w opisie produktu.\n\nPamietaj, ze nie jestesmy powiazani z markami, ktore sprzedajemy.",
    "product.returns_shipping": "Zwroty i Wysylka Miedzynarodowa",
    "product.returns_shipping_content": "KLIENCI MIEDZYNARODOWI: Cla i podatki importowe nie sa wliczone w cene zakupu i beda fakturowane oddzielnie przez kuriera. Jesli nie zaplacisz cel, Twoje zamowienie zostanie do nas zwrocone. Podatek nadal zostanie obciazony na naszym koncie wraz z kosztami zwrotu i oplata administracyjna 50 EUR. Oplaty te zostana naliczone klientowi lub odliczone od kredytu sklepowego. Zwroty pieniedzy beda wydawane tylko jesli kurier zwroci Mona Luxe te koszty, co nie jest gwarantowane.\n\nZWROTY\n\nProdukty dostepne w sklepie Mona Luxe sa sprzedawane na zasadzie komisu. Mona Luxe nie akceptuje zwrotow z gotowkowym zwrotem pieniedzy. Polityka ta jest zgodna z modelem sprzedazy konsument-do-konsumenta stosowanym przez inne platformy pre-loved w UE.\n\nBiorac pod uwage pre-loved charakter naszych produktow, niektore przedmioty moga wykazywac slady uzytkowania. Zdecydowanie zalecamy uwazne zapoznanie sie z opisami i zdjeciami przed dokonaniem zakupu. Wszystkie przedmioty sa sprzedawane w stanie widocznym na zdjeciach. Gwarantujemy autentycznosc kazdego przedmiotu sprzedawanego przez Mona Luxe. Jesli przedmiot okaze sie nieautentyczny, kupujacy otrzyma pelny zwrot pieniedzy.\n\nKlienci ponosza koszty wysylki zwrotnej. Mozemy zapewnic etykiete wysylkowa dla Twojej wygody. Jesli zorganizujesz wlasna wysylke, ponosisz odpowiedzialnosc za sledzenie przesylki oraz ewentualne straty lub uszkodzenia. Kupujacy miedzynarodowi musza upewnic sie, ze deklaracja celna jest poprawnie wypelniona przy zwrotach.\n\nZwrot zamowienia bez worka przeciwkurzowego Mona Luxe spowoduje oplate 25 EUR odliczona od kredytu sklepowego.\n\nArtykuly z wyprzedazy nie podlegaja zwrotowi. Te artykuly sa uznawane za sprzedaz ostateczna.\n\nOd daty otrzymania zamowienia masz 2 dni, aby skontaktowac sie z naszym zespolem obslugi klienta i zainicjowac zwrot w celu wymiany lub kredytu sklepowego. Po potwierdzeniu metody zwrotu, przedmiot musi zostac zwrocony w ciagu 5-7 dni.\n\nANULOWANIE ZAMOWIENIA\n\nJesli chcesz anulowac zamowienie, otrzymasz kredyt sklepowy zamiast zwrotu gotowki.\n\nZAKUPY W SKLEPIE, SHOWROOMIE I POP-UP\n\nZwroty nie sa akceptowane dla zakupow dokonanych w sklepie lub na wydarzeniach pop-up; wszystkie sprzedaze sa ostateczne.",
    "cart.title": "Koszyk",
    "cart.empty": "Twoj koszyk jest pusty",
    "cart.empty_title": "Twoj Koszyk Jest Pusty",
    "cart.empty_subtitle": "Przegladaj nasza kolekcje",
    "cart.shop_now": "Kup Teraz",
    "cart.summary": "Podsumowanie Zamowienia",
    "cart.total": "Razem",
    "cart.subtotal": "Suma czesciowa",
    "cart.checkout": "Przejdz do Platnosci",
    "checkout.title": "Platnosc",
    "checkout.proceed": "Kontynuuj",
    "checkout.pay_now": "Zaplac Teraz",
    "checkout.back_to_cart": "Wrocic do Koszyka",
    "checkout.first_name": "Imie",
    "checkout.last_name": "Nazwisko",
    "checkout.email": "E-mail",
    "checkout.phone": "Telefon",
    "checkout.address": "Adres",
    "checkout.city": "Miasto",
    "checkout.postal_code": "Kod Pocztowy",
    "checkout.country": "Kraj",
    "checkout.discount_code": "Kod Rabatowy",
    "checkout.apply": "Zastosuj",
    "checkout.discount": "Rabat",
    "checkout.fill_required": "Wypelnij wymagane pola",
    "admin.create_code": "Utworz Kod",
    "admin.type": "Typ",
    "admin.percentage": "Procent",
    "admin.fixed_amount": "Stala Kwota",
    "admin.value": "Wartosc",
    "admin.usage_limit": "Limit Uzycia",
    "admin.min_order": "Min Zamowienie",
    "cart.remove": "Usun",
    "cart.quantity": "Ilosc",
    "cart.continue": "Kontynuuj Zakupy",
    "cart.ship_to": "Wysylka do",
    "cart.select_country": "Wybierz kraj",
    "cart.shipping": "Wysylka",
    "cart.business_days": "dni roboczych",
    "cart.free": "Bezplatnie",
    "cart.free_shipping": "Bezplatna wysylka",
    "cart.free_shipping_from": "Bezplatna wysylka od",
    "wishlist.title": "Lista Zyczen",
    "wishlist.empty": "Twoja lista zyczen jest pusta",
    "wishlist.move_to_cart": "Dodaj do Koszyka",
    "checkout.success": "Dziekujemy za Zakup",
    "checkout.processing": "Przetwarzanie platnosci...",
    "checkout.failed": "Platnosc nie mogla zostac przetworzona",
    "checkout.continue": "Kontynuuj Zakupy",
    "checkout.order_confirmed": "Twoje zamowienie zostalo potwierdzone",
    "admin.title": "Administracja",
    "admin.login": "Zaloguj sie",
    "admin.password": "Haslo",
    "admin.products": "Produkty",
    "admin.orders": "Zamowienia",
    "admin.add": "Dodaj Produkt",
    "admin.edit": "Edytuj",
    "admin.delete": "Usun",
    "admin.upload_photo": "Przeslij Zdjecie",
    "admin.stock_quantity": "Ilosc na Stanie",
    "admin.discount": "Rabat",
    "admin.save": "Zapisz",
    "admin.cancel": "Anuluj",
    "admin.name": "Nazwa",
    "admin.brand": "Marka",
    "admin.category": "Kategoria",
    "admin.price": "Cena",
    "admin.description": "Opis",
    "admin.images": "URL-e obrazow (po jednym w linii)",
    "admin.featured": "Wyrozniony",
    "admin.in_stock": "Dostepny",
    "admin.logout": "Wyloguj sie",
    "admin.no_orders": "Brak zamowien",
    "admin.order_id": "Nr Zamowienia",
    "admin.amount": "Kwota",
    "admin.status": "Status",
    "admin.date": "Data",
    "footer.about": "O Mona Luxe",
    "footer.about_text": "Wyselekcjonowane miejsce dla najlepszych torebek designerskich.",
    "footer.customer_care": "Obsluga Klienta",
    "footer.shipping_info": "Informacje o Wysylce",
    "footer.returns_policy": "Zwroty i Wymiany",
    "footer.contact": "Kontakt",
    "footer.faq": "FAQ",
    "footer.authenticity": "Authenticity Guarantee",
    "footer.legal": "Prawne",
    "footer.privacy": "Polityka Prywatnosci",
    "footer.terms": "Regulamin",
    "footer.cookies": "Polityka Cookies",
    "footer.follow": "Obserwuj Nas",
    "footer.newsletter": "Newsletter",
    "footer.newsletter_text": "Zapisz sie na wylaczny dostep do nowosci",
    "footer.subscribe": "Subskrybuj",
    "footer.email_placeholder": "Twoj adres email",
    "footer.rights": "Wszelkie prawa zastrzezone",
    "common.loading": "Ladowanie...",
    "common.error": "Cos poszlo nie tak",
    "common.back": "Wstecz",
    "common.close": "Zamknij",
  },
  cs: {
    "nav.home": "Domov",
    "nav.shop": "Obchod",
    "nav.wishlist": "Seznam Prani",
    "nav.cart": "Kosik",
    "nav.admin": "Administrace",
    "nav.search": "Hledat",
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "Pro Nej. Pro Ni.",
    "hero.subtitle": "Overeny pre-owned luxus — kabelky, crossbody, cestovni — pro kazdy satnik.",
    "hero.cta": "Prozkoumat Kolekci",
    "home.featured": "Doporucene",
    "home.featured_subtitle": "Rucne vybrane kousky z novych dodavek",
    "home.brands": "Nase Modove Domy",
    "home.brands_subtitle": "Nejprestiznejsi modove domy na svete",
    "home.view_all": "Zobrazit Vse",
    "home.new_arrivals": "Novinky",
    "shop.title": "Kolekce",
    "shop.filters": "Filtry",
    "shop.brand": "Znacka",
    "shop.category": "Kategorie",
    "shop.price": "Cenove Rozpeti",
    "shop.all": "Vse",
    "shop.clear": "Smazat Filtry",
    "shop.no_results": "Zadne produkty nenalezeny",
    "shop.results": "produktu",
    "shop.sort": "Radit",
    "shop.sort_popular": "Popularni",
    "shop.sort_newest": "Nejnovejsi",
    "shop.sort_price_asc": "Cena: Vzestupne",
    "shop.sort_price_desc": "Cena: Sestupne",
    "shop.load_more": "Nacist Vice",
    "shop.loading": "Nacitani...",
    "search.placeholder": "Hledat tasky, znacky...",
    "product.add_cart": "Pridat do Kosiku",
    "product.add_wishlist": "Pridat do Seznamu Prani",
    "product.remove_wishlist": "Odebrat ze Seznamu Prani",
    "product.in_stock": "Skladem",
    "product.out_of_stock": "Vyprodano",
    "product.description": "Popis",
    "product.details": "Podrobnosti",
    "product.authenticity": "Zaruka Pravosti",
    "product.fast_delivery": "Rychle Doruceni",
    "product.max_stock": "Dosazeno maximalniho dostupneho mnozstvi",
    "product.further_info": "Dalsi Informace",
    "product.further_info_content": "Vsechny nase polozky jsou doplneny zarukou pravosti. Pro ochranu vasi investice bude vas produkt dorucen v prachovem sacku Mona Luxe a znackovem baleni.\n\nProdukty prodavane spolecnosti Mona Luxe jsou pouzite, pokud neni uvedeno jinak. Nase kousky mely predchozi zivot a mohou vypravet svuj pribeh drobnymi stopami opotrebeni. Vyraznejsi stopy opotrebeni budou uvedeny v popisu produktu.\n\nUpozornujeme, ze nejsme spojeni se znackami, ktere prodavame.",
    "product.returns_shipping": "Vraceni a Mezinarodni Doprava",
    "product.returns_shipping_content": "MEZINARODNI ZAKAZNICI: Dovozni cla a dane nejsou zahrnuty v kupni cene a budou uctovany samostatne prepravcem. Pokud nezaplatite dovozni cla, vase objednavka nam bude vracena. Dan bude i tak uctovana na nas ucet spolu s naklady na zpetne doruceni a administrativnim poplatkem 50 EUR. Tyto poplatky budou uctovany zakaznikovi nebo odecteny z kreditu obchodu. Refundace budou vydany pouze pokud prepravce vrati Mona Luxe tyto naklady, coz neni zaruceno.\n\nVRACENI\n\nPolozky dostupne na webu Mona Luxe jsou prodavany na komisi. Mona Luxe nepriznava vraceni za hotovostni refundaci. Tato politika je v souladu s modelem prodeje spotrebitel-spotrebiteli pouzivanym jinymi pre-loved platformami v EU.\n\nVzhledem k pre-loved povaze nasich produktu mohou nektere polozky vykazovat stopy opotrebeni. Duraznejen doporucujeme peclive prostudovat popisy a fotografie pred nakupem. Vsechny polozky se prodavaji tak, jak jsou zobrazeny. Garantujeme pravost kazde polozky prodavane prostrednictvim Mona Luxe. Pokud se zjisti, ze polozka neni pravá, kupujici obdrzi plnou refundaci.\n\nZakaznici nesou naklady na zpetne dorucení. Pro vase pohodli muzeme poskytnout dorucovaci stitek. Pokud si organizujete vlastni doruceni, nesete odpovednost za sledovani zasilky a pripadne ztraty ci poskozeni. Mezinarodni kupujici musi zajistit, aby celni prohlaseni bylo pri vraceni spravne vyplneno.\n\nVraceni objednavky bez prachoveho sacku Mona Luxe povede k poplatku 25 EUR odectenemu z kreditu obchodu.\n\nZbozi ve vyprodeji nelze vratit. Tyto polozky jsou povazovany za konecny prodej.\n\nOde dne prijeti objednavky mate 2 dny na kontaktovani naseho zakaznickeho servisu pro zahajeni vraceni za vymenu nebo kredit obchodu. Po potvrzeni zpusobu vraceni musi byt zbozi vraceno do 5-7 dni.\n\nZRUSENI OBJEDNAVKY\n\nPokud si prejete zrusit svou objednavku, obdrzite kredit obchodu misto hotovostni refundace.\n\nNAKUPY V OBCHODE, SHOWROOMU A POP-UP\n\nVraceni nejsou akceptovana u nakupu uskutecnenych v obchode nebo na pop-up akcich; vsechny prodeje jsou konecne.",
    "cart.title": "Nakupni Kosik",
    "cart.empty": "Vas kosik je prazdny",
    "cart.empty_title": "Vas Kosik je Prazdny",
    "cart.empty_subtitle": "Prohlednete si nasi kolekci",
    "cart.shop_now": "Nakupovat",
    "cart.summary": "Prehled Objednavky",
    "cart.total": "Celkem",
    "cart.subtotal": "Mezisouset",
    "cart.checkout": "Prejit k Platbe",
    "checkout.title": "Platba",
    "checkout.proceed": "Pokracovat",
    "checkout.pay_now": "Zaplatit",
    "checkout.back_to_cart": "Zpet do Kosiku",
    "checkout.first_name": "Jmeno",
    "checkout.last_name": "Prijmeni",
    "checkout.email": "E-mail",
    "checkout.phone": "Telefon",
    "checkout.address": "Adresa",
    "checkout.city": "Mesto",
    "checkout.postal_code": "PSC",
    "checkout.country": "Zeme",
    "checkout.discount_code": "Slevovy Kod",
    "checkout.apply": "Pouzit",
    "checkout.discount": "Sleva",
    "checkout.fill_required": "Vyplnte povinne udaje",
    "admin.create_code": "Vytvorit Kod",
    "admin.type": "Typ",
    "admin.percentage": "Procento",
    "admin.fixed_amount": "Pevna Castka",
    "admin.value": "Hodnota",
    "admin.usage_limit": "Limit Pouziti",
    "admin.min_order": "Min Objednavka",
    "cart.remove": "Odebrat",
    "cart.quantity": "Ks",
    "cart.continue": "Pokracovat v Nakupu",
    "cart.ship_to": "Doruceni do",
    "cart.select_country": "Vyberte zemi",
    "cart.shipping": "Doprava",
    "cart.business_days": "pracovnich dni",
    "cart.free": "Zdarma",
    "cart.free_shipping": "Doprava zdarma v cene",
    "cart.free_shipping_from": "Doprava zdarma od",
    "wishlist.title": "Seznam Prani",
    "wishlist.empty": "Vas seznam prani je prazdny",
    "wishlist.move_to_cart": "Pridat do Kosiku",
    "checkout.success": "Dekujeme za Vas Nakup",
    "checkout.processing": "Zpracovani platby...",
    "checkout.failed": "Platbu nelze zpracovat",
    "checkout.continue": "Pokracovat v Nakupu",
    "checkout.order_confirmed": "Vase objednavka byla potvrzena",
    "admin.title": "Administrace",
    "admin.login": "Prihlasit se",
    "admin.password": "Heslo",
    "admin.products": "Produkty",
    "admin.orders": "Objednavky",
    "admin.add": "Pridat Produkt",
    "admin.edit": "Upravit",
    "admin.delete": "Smazat",
    "admin.upload_photo": "Nahrat Fotku",
    "admin.stock_quantity": "Mnozstvi na Sklade",
    "admin.discount": "Sleva",
    "admin.save": "Ulozit",
    "admin.cancel": "Zrusit",
    "admin.name": "Nazev",
    "admin.brand": "Znacka",
    "admin.category": "Kategorie",
    "admin.price": "Cena",
    "admin.description": "Popis",
    "admin.images": "URL obrazku (jeden na radek)",
    "admin.featured": "Doporuceny",
    "admin.in_stock": "Skladem",
    "admin.logout": "Odhlasit se",
    "admin.no_orders": "Zatim zadne objednavky",
    "admin.order_id": "Cislo Objednavky",
    "admin.amount": "Castka",
    "admin.status": "Stav",
    "admin.date": "Datum",
    "footer.about": "O Mona Luxe",
    "footer.about_text": "Kuratovana destinace pro nejlepsi designerske kabelky.",
    "footer.customer_care": "Zakaznicka Podpora",
    "footer.shipping_info": "Informace o Doruceni",
    "footer.returns_policy": "Vraceni a Vymena",
    "footer.contact": "Kontaktujte Nas",
    "footer.faq": "Caste Dotazy",
    "footer.authenticity": "Zaruka Pravosti",
    "footer.legal": "Pravni Informace",
    "footer.privacy": "Zasady Ochrany Soukromi",
    "footer.terms": "Obchodni Podminky",
    "footer.cookies": "Zasady Cookies",
    "footer.follow": "Sledujte Nas",
    "footer.newsletter": "Newsletter",
    "footer.newsletter_text": "Prihiaste se k exkluzivnimu pristupu k novinkam",
    "footer.subscribe": "Odebrat",
    "footer.email_placeholder": "Vas email",
    "footer.rights": "Vsechna prava vyhrazena",
    "common.loading": "Nacitani...",
    "common.error": "Neco se pokazilo",
    "common.back": "Zpet",
    "common.close": "Zavrit",
  },
  uk: {
    "nav.home": "Головна",
    "nav.shop": "Магазин",
    "nav.wishlist": "Список бажань",
    "nav.cart": "Кошик",
    "nav.admin": "Адмiнiстрування",
    "nav.search": "Пошук",
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "Для Нього. Для Неї.",
    "hero.subtitle": "Автентифікована преміум-мода з вторинного ринку — сумки, крос-боді, дорожні — для будь-якого гардеробу.",
    "hero.cta": "Дослiдити Колекцiю",
    "home.featured": "Рекомендованi",
    "home.featured_subtitle": "Вiдiбранi речi з нових надходжень",
    "home.brands": "Нашi Модні Дома",
    "home.brands_subtitle": "Найпрестижнiшi модні дома свiту",
    "home.view_all": "Дивитись Все",
    "home.new_arrivals": "Новинки",
    "shop.title": "Колекцiя",
    "shop.filters": "Фiльтри",
    "shop.brand": "Бренд",
    "shop.category": "Категорiя",
    "shop.price": "Цiновий Дiапазон",
    "shop.all": "Все",
    "shop.clear": "Очистити Фiльтри",
    "shop.no_results": "Товарiв не знайдено",
    "shop.results": "товарiв",
    "shop.sort": "Сортувати",
    "shop.sort_popular": "Популярнi",
    "shop.sort_newest": "Найновiшi",
    "shop.sort_price_asc": "Цiна: Вiд низької до високої",
    "shop.sort_price_desc": "Цiна: Вiд високої до низької",
    "shop.load_more": "Завантажити бiльше",
    "shop.loading": "Завантаження...",
    "search.placeholder": "Шукати сумки, бренди...",
    "product.add_cart": "Додати до Кошика",
    "product.add_wishlist": "Додати до Списку бажань",
    "product.remove_wishlist": "Видалити зi Списку бажань",
    "product.in_stock": "В наявностi",
    "product.out_of_stock": "Немає в наявностi",
    "product.description": "Опис",
    "product.details": "Деталi",
    "product.authenticity": "Гарантiя Автентичностi",
    "product.fast_delivery": "Швидка Доставка",
    "product.max_stock": "Досягнуто максимальну доступну кiлькiсть",
    "product.further_info": "Додаткова Інформація",
    "product.further_info_content": "Усі наші товари мають гарантію автентичності. Щоб захистити вашу інвестицію, ваш товар буде доставлено у пиловому мішечку Mona Luxe та фірмовій упаковці.\n\nТовари Mona Luxe є вживаними, якщо не вказано інше. Наші речі мали попереднє життя і можуть мати незначні сліди використання. Більш помітні сліди використання вказуються в описі товару.\n\nЗверніть увагу: ми не пов'язані з брендами, які продаємо.",
    "product.returns_shipping": "Повернення та Міжнародна Доставка",
    "product.returns_shipping_content": "МІЖНАРОДНІ КЛІЄНТИ: Митні збори та податки не входять у вартість покупки та будуть стягнуті кур'єром окремо. Якщо ви не оплатите мита, ваше замовлення буде повернуто нам. Податок все одно буде нарахований на наш рахунок разом із вартістю зворотної доставки та адміністративним збором 50 EUR. Ці витрати буде стягнуто з клієнта або вирахувано з кредиту магазину. Повернення коштів здійснюються лише за умови відшкодування кур'єром Mona Luxe цих витрат, що не гарантовано.\n\nПОВЕРНЕННЯ\n\nТовари, доступні на сайті Mona Luxe, продаються на комісійній основі. Mona Luxe не приймає повернення з готівковим відшкодуванням за придбані товари. Ця політика відповідає моделі продажу споживач-споживачу, яку використовують інші pre-loved платформи в ЄС.\n\nЗважаючи на pre-loved природу наших товарів, деякі речі можуть мати сліди використання. Ми наполегливо рекомендуємо уважно вивчати описи та фотографії перед покупкою. Усі товари продаються \"як є\". Ми гарантуємо автентичність кожного товару, проданого через Mona Luxe. Якщо товар виявиться неавтентичним, покупець отримає повне відшкодування.\n\nКлієнти несуть витрати на зворотну доставку. Для вашої зручності ми можемо надати транспортну етикетку. Якщо ви організовуєте власну доставку, ви відповідаєте за відстеження посилки та можливі втрати чи пошкодження. Міжнародні покупці повинні переконатися, що митна декларація заповнена правильно для повернень.\n\nПовернення замовлення без пилового мішечка Mona Luxe призведе до сплати 25 EUR, що буде вирахувано з кредиту магазину.\n\nТовари зі знижкою не підлягають поверненню. Такі товари вважаються остаточним продажем.\n\nЗ моменту отримання замовлення ви маєте 2 дні, щоб зв'язатися з нашою службою підтримки для оформлення повернення на обмін або кредит магазину. Після підтвердження способу повернення товар має бути повернуто протягом 5-7 днів.\n\nСКАСУВАННЯ ЗАМОВЛЕННЯ\n\nЯкщо ви хочете скасувати замовлення, ви отримаєте кредит магазину замість готівкового відшкодування.\n\nПОКУПКИ В МАГАЗИНІ, ШОУРУМІ ТА POP-UP\n\nПовернення не приймаються для покупок, здійснених у магазині або на pop-up заходах; усі продажі остаточні.",
    "cart.title": "Кошик",
    "cart.empty": "Ваш кошик порожнiй",
    "cart.empty_title": "Ваш Кошик Порожнiй",
    "cart.empty_subtitle": "Переглядайте нашу колекцiю",
    "cart.shop_now": "До Магазину",
    "cart.summary": "Пiдсумок Замовлення",
    "cart.total": "Разом",
    "cart.subtotal": "Пiдсумок",
    "cart.checkout": "Перейти до Оплати",
    "checkout.title": "Оформлення",
    "checkout.proceed": "Продовжити",
    "checkout.pay_now": "Сплатити",
    "checkout.back_to_cart": "Повернутися до Кошика",
    "checkout.first_name": "Iм'я",
    "checkout.last_name": "Прiзвище",
    "checkout.email": "E-mail",
    "checkout.phone": "Телефон",
    "checkout.address": "Адреса",
    "checkout.city": "Мiсто",
    "checkout.postal_code": "Поштовий Iндекс",
    "checkout.country": "Країна",
    "checkout.discount_code": "Промокод",
    "checkout.apply": "Застосувати",
    "checkout.discount": "Знижка",
    "checkout.fill_required": "Заповнiть обов'язковi поля",
    "admin.create_code": "Створити Код",
    "admin.type": "Тип",
    "admin.percentage": "Вiдсоток",
    "admin.fixed_amount": "Фiксована Сума",
    "admin.value": "Значення",
    "admin.usage_limit": "Лiмiт Використання",
    "admin.min_order": "Мiн Замовлення",
    "cart.remove": "Видалити",
    "cart.quantity": "Кiлькiсть",
    "cart.continue": "Продовжити Покупки",
    "cart.ship_to": "Доставка в",
    "cart.select_country": "Виберіть країну",
    "cart.shipping": "Доставка",
    "cart.business_days": "робочих днів",
    "cart.free": "Безкоштовно",
    "cart.free_shipping": "Безкоштовна доставка",
    "cart.free_shipping_from": "Безкоштовна доставка від",
    "wishlist.title": "Список Бажань",
    "wishlist.empty": "Ваш список бажань порожнiй",
    "wishlist.move_to_cart": "Додати до Кошика",
    "checkout.success": "Дякуємо за Покупку",
    "checkout.processing": "Обробка платежу...",
    "checkout.failed": "Платiж не вдалося обробити",
    "checkout.continue": "Продовжити Покупки",
    "checkout.order_confirmed": "Ваше замовлення пiдтверджено",
    "admin.title": "Адмiнiстрування",
    "admin.login": "Увiйти",
    "admin.password": "Пароль",
    "admin.products": "Товари",
    "admin.orders": "Замовлення",
    "admin.add": "Додати Товар",
    "admin.edit": "Редагувати",
    "admin.delete": "Видалити",
    "admin.upload_photo": "Завантажити Фото",
    "admin.stock_quantity": "Кiлькiсть на Складi",
    "admin.discount": "Знижка",
    "admin.save": "Зберегти",
    "admin.cancel": "Скасувати",
    "admin.name": "Назва",
    "admin.brand": "Бренд",
    "admin.category": "Категорiя",
    "admin.price": "Цiна",
    "admin.description": "Опис",
    "admin.images": "URL зображень (одне на рядок)",
    "admin.featured": "Рекомендований",
    "admin.in_stock": "В наявностi",
    "admin.logout": "Вийти",
    "admin.no_orders": "Замовлень ще немає",
    "admin.order_id": "Номер Замовлення",
    "admin.amount": "Сума",
    "admin.status": "Статус",
    "admin.date": "Дата",
    "footer.about": "Про Mona Luxe",
    "footer.about_text": "Вишуканий простiр для найкращих дизайнерських сумок свiту.",
    "footer.customer_care": "Обслуговування Клiєнтiв",
    "footer.shipping_info": "Iнформацiя про Доставку",
    "footer.returns_policy": "Повернення та Обмiн",
    "footer.contact": "Зв'язатися з Нами",
    "footer.faq": "Часті Питання",
    "footer.authenticity": "Гарантiя Автентичностi",
    "footer.legal": "Юридична Iнформацiя",
    "footer.privacy": "Полiтика Конфiденцiйностi",
    "footer.terms": "Умови Використання",
    "footer.cookies": "Полiтика Файлiв Cookie",
    "footer.follow": "Слiдкуйте за Нами",
    "footer.newsletter": "Розсилка",
    "footer.newsletter_text": "Пiдпишiться для ексклюзивного доступу до новинок",
    "footer.subscribe": "Пiдписатися",
    "footer.email_placeholder": "Ваша електронна адреса",
    "footer.rights": "Усi права захищенi",
    "common.loading": "Завантаження...",
    "common.error": "Щось пiшло не так",
    "common.back": "Назад",
    "common.close": "Закрити",
  },
  ru: {
    "nav.home": "Главная",
    "nav.shop": "Магазин",
    "nav.wishlist": "Избранное",
    "nav.cart": "Корзина",
    "nav.admin": "Администрирование",
    "nav.search": "Поиск",
    "hero.title": "Worn. Loved. Next.",
    "hero.eyebrow": "Для Него. Для Неё.",
    "hero.subtitle": "Аутентифицированный pre-owned люкс — сумки, кросс-боди, дорожные — для любого гардероба.",
    "hero.cta": "Исследовать Коллекцию",
    "home.featured": "Рекомендуемые",
    "home.featured_subtitle": "Отборные вещи из новых поступлений",
    "home.brands": "Наши Модные Дома",
    "home.brands_subtitle": "Самые престижные модные дома мира",
    "home.view_all": "Смотреть Все",
    "home.new_arrivals": "Новинки",
    "shop.title": "Коллекция",
    "shop.filters": "Фильтры",
    "shop.brand": "Бренд",
    "shop.category": "Категория",
    "shop.price": "Ценовой Диапазон",
    "shop.all": "Все",
    "shop.clear": "Очистить Фильтры",
    "shop.no_results": "Товары не найдены",
    "shop.results": "товаров",
    "shop.sort": "Сортировка",
    "shop.sort_popular": "Популярные",
    "shop.sort_newest": "Новейшие",
    "shop.sort_price_asc": "Цена: По возрастанию",
    "shop.sort_price_desc": "Цена: По убыванию",
    "shop.load_more": "Загрузить ещё",
    "shop.loading": "Загрузка...",
    "search.placeholder": "Поиск сумок, брендов...",
    "product.add_cart": "Добавить в Корзину",
    "product.add_wishlist": "Добавить в Избранное",
    "product.remove_wishlist": "Удалить из Избранного",
    "product.in_stock": "В наличии",
    "product.out_of_stock": "Нет в наличии",
    "product.description": "Описание",
    "product.details": "Детали",
    "product.authenticity": "Гарантия Подлинности",
    "product.fast_delivery": "Быстрая Доставка",
    "product.max_stock": "Достигнуто максимальное доступное количество",
    "product.further_info": "Дополнительная Информация",
    "product.further_info_content": "Все наши изделия имеют гарантию подлинности. Чтобы защитить вашу инвестицию, продукт будет доставлен в фирменном пыльнике Mona Luxe и подарочной упаковке.\n\nТовары Mona Luxe являются бывшими в употреблении, если не указано иное. Наши изделия имели предыдущую жизнь и могут демонстрировать свою историю в виде незначительных следов использования. Более заметные следы будут указаны в описании товара.\n\nОбратите внимание: мы не аффилированы с брендами, которые продаём.",
    "product.returns_shipping": "Возврат и Международная Доставка",
    "product.returns_shipping_content": "МЕЖДУНАРОДНЫЕ КЛИЕНТЫ: Таможенные пошлины и налоги не включены в цену покупки и будут выставлены курьером отдельно. Если вы не оплатите импортные пошлины, ваш заказ будет возвращён нам. Налог всё равно будет списан с нашего счёта вместе со стоимостью обратной доставки и административным сбором 50 EUR. Эти расходы будут выставлены клиенту или удержаны из кредита магазина. Возврат средств производится только при условии, что курьер возместит Mona Luxe эти расходы, что не гарантировано.\n\nВОЗВРАТ\n\nТовары, доступные на сайте Mona Luxe, продаются на комиссионной основе. Mona Luxe не принимает возврат с возвратом средств наличными за приобретённые товары. Эта политика соответствует модели продаж потребитель-потребителю, используемой другими pre-loved платформами в ЕС.\n\nУчитывая pre-loved природу наших товаров, некоторые изделия могут иметь следы использования. Мы настоятельно рекомендуем внимательно изучать описания и фотографии перед покупкой. Все товары продаются «как есть». Мы гарантируем подлинность каждого товара, проданного через Mona Luxe. Если товар окажется неподлинным, покупатель получит полное возмещение.\n\nКлиенты несут расходы по обратной доставке. Для вашего удобства мы можем предоставить транспортную этикетку. Если вы организуете доставку самостоятельно, вы несёте ответственность за отслеживание посылки и возможную потерю или повреждение. Международные покупатели должны убедиться, что таможенная декларация при возврате заполнена корректно.\n\nВозврат заказа без фирменного пыльника Mona Luxe повлечёт сбор 25 EUR, удерживаемый из кредита магазина.\n\nТовары со скидкой возврату не подлежат. Такие товары считаются окончательной продажей.\n\nС даты получения заказа у вас есть 2 дня, чтобы связаться с нашей службой поддержки и инициировать возврат для обмена или кредита магазина. После подтверждения способа возврата товар должен быть возвращён в течение 5-7 дней.\n\nОТМЕНА ЗАКАЗА\n\nЕсли вы хотите отменить заказ, вы получите кредит магазина вместо возврата наличными.\n\nПОКУПКИ В МАГАЗИНЕ, ШОУРУМЕ И POP-UP\n\nВозврат не принимается для покупок, совершённых в магазине или на pop-up мероприятиях; все продажи окончательны.",
    "cart.title": "Корзина",
    "cart.empty": "Ваша корзина пуста",
    "cart.empty_title": "Ваша Корзина Пуста",
    "cart.empty_subtitle": "Просмотрите нашу коллекцию",
    "cart.shop_now": "За Покупками",
    "cart.summary": "Итого Заказа",
    "cart.total": "Итого",
    "cart.subtotal": "Промежуточный итог",
    "cart.checkout": "Перейти к Оплате",
    "checkout.title": "Оформление",
    "checkout.proceed": "Продолжить",
    "checkout.pay_now": "Оплатить",
    "checkout.back_to_cart": "Вернуться в Корзину",
    "checkout.first_name": "Имя",
    "checkout.last_name": "Фамилия",
    "checkout.email": "E-mail",
    "checkout.phone": "Телефон",
    "checkout.address": "Адрес",
    "checkout.city": "Город",
    "checkout.postal_code": "Почтовый Индекс",
    "checkout.country": "Страна",
    "checkout.discount_code": "Промокод",
    "checkout.apply": "Применить",
    "checkout.discount": "Скидка",
    "checkout.fill_required": "Заполните обязательные поля",
    "admin.create_code": "Создать Код",
    "admin.type": "Тип",
    "admin.percentage": "Процент",
    "admin.fixed_amount": "Фиксированная Сумма",
    "admin.value": "Значение",
    "admin.usage_limit": "Лимит Использования",
    "admin.min_order": "Мин Заказ",
    "cart.remove": "Удалить",
    "cart.quantity": "Кол-во",
    "cart.continue": "Продолжить Покупки",
    "cart.ship_to": "Доставка в",
    "cart.select_country": "Выберите страну",
    "cart.shipping": "Доставка",
    "cart.business_days": "рабочих дней",
    "cart.free": "Бесплатно",
    "cart.free_shipping": "Бесплатная доставка",
    "cart.free_shipping_from": "Бесплатная доставка от",
    "wishlist.title": "Избранное",
    "wishlist.empty": "Ваш список избранного пуст",
    "wishlist.move_to_cart": "Добавить в Корзину",
    "checkout.success": "Спасибо за Покупку",
    "checkout.processing": "Обработка платежа...",
    "checkout.failed": "Платёж не удалось обработать",
    "checkout.continue": "Продолжить Покупки",
    "checkout.order_confirmed": "Ваш заказ подтверждён",
    "admin.title": "Администрирование",
    "admin.login": "Войти",
    "admin.password": "Пароль",
    "admin.products": "Товары",
    "admin.orders": "Заказы",
    "admin.add": "Добавить Товар",
    "admin.edit": "Редактировать",
    "admin.delete": "Удалить",
    "admin.upload_photo": "Загрузить Фото",
    "admin.stock_quantity": "Количество на Складе",
    "admin.discount": "Скидка",
    "admin.save": "Сохранить",
    "admin.cancel": "Отменить",
    "admin.name": "Название",
    "admin.brand": "Бренд",
    "admin.category": "Категория",
    "admin.price": "Цена",
    "admin.description": "Описание",
    "admin.images": "URL изображений (по одному на строку)",
    "admin.featured": "Рекомендуемый",
    "admin.in_stock": "В наличии",
    "admin.logout": "Выйти",
    "admin.no_orders": "Заказов пока нет",
    "admin.order_id": "Номер Заказа",
    "admin.amount": "Сумма",
    "admin.status": "Статус",
    "admin.date": "Дата",
    "footer.about": "О Mona Luxe",
    "footer.about_text": "Изысканное пространство для лучших дизайнерских сумок мира.",
    "footer.customer_care": "Обслуживание Клиентов",
    "footer.shipping_info": "Информация о Доставке",
    "footer.returns_policy": "Возврат и Обмен",
    "footer.contact": "Связаться с Нами",
    "footer.faq": "Частые Вопросы",
    "footer.authenticity": "Гарантия Подлинности",
    "footer.legal": "Юридическая Информация",
    "footer.privacy": "Политика Конфиденциальности",
    "footer.terms": "Условия Использования",
    "footer.cookies": "Политика Файлов Cookie",
    "footer.follow": "Следите за Нами",
    "footer.newsletter": "Рассылка",
    "footer.newsletter_text": "Подпишитесь для эксклюзивного доступа к новинкам",
    "footer.subscribe": "Подписаться",
    "footer.email_placeholder": "Ваш адрес электронной почты",
    "footer.rights": "Все права защищены",
    "common.loading": "Загрузка...",
    "common.error": "Что-то пошло не так",
    "common.back": "Назад",
    "common.close": "Закрыть",
  },
};

export default translations;
